/* ==========================================================================
   GÖRL — Theme-Interaktion (Vanilla, keine Abhängigkeiten)
   Grundsatz: Motion, die orientiert. Alles respektiert prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Scroll-Reveal ------------------------------------------------------ */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Header: beschatten + beim Runterscrollen ausblenden ---------------- */
  function initHeader() {
    var hdr = document.querySelector('[data-header]');
    if (!hdr) return;
    var last = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      hdr.dataset.scrolled = y > 8 ? 'true' : 'false';
      // Nur ausblenden, wenn weit genug unten und das Mobile-Menü zu ist
      var menuOpen = hdr.querySelector('[data-mobile-menu][data-open="true"]');
      if (!menuOpen && y > 240 && y > last + 4) {
        hdr.dataset.hidden = 'true';
      } else if (y < last - 4 || y < 120) {
        hdr.dataset.hidden = 'false';
      }
      last = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* --- Mobile-Menü -------------------------------------------------------- */
  function initMobileMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!btn || !menu) return;

    function setOpen(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.dataset.open = open ? 'true' : 'false';
      btn.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    }
    btn.addEventListener('click', function () {
      setOpen(btn.getAttribute('aria-expanded') !== 'true');
    });
    // Schließen bei Escape und bei Klick auf einen Link
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        setOpen(false); btn.focus();
      }
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
  }

  /* --- FAQ-Akkordeon ------------------------------------------------------ */
  function initFaq() {
    document.querySelectorAll('[data-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.dataset.open = open ? 'false' : 'true';
      });
    });
  }

  /* --- Sticky CTA auf Mobil (erscheint, sobald der Hero durch ist) -------- */
  function initStickyCta() {
    var bar = document.querySelector('[data-sticky-cta]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar) return;
    if (!anchor || !('IntersectionObserver' in window)) { bar.dataset.visible = 'true'; return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* --- Init --------------------------------------------------------------- */
  function init() {
    initReveal();
    initHeader();
    initMobileMenu();
    initFaq();
    initStickyCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme-Editor: Sections neu initialisieren
  document.addEventListener('shopify:section:load', init);
})();
